import {
  ADD_ASSIGN_FAILED,
  ADD_ASSIGN_SUCCESS,
  EDIT_ASSIGN_FAILED,
  EDIT_ASSIGN_SUCCESS,
  EDIT_USER_ASSIGN_DATA,
  LIST_ASSIGN_USER_FAILED,
  LIST_ASSIGN_USER_SUCCESS,
  LOADING_FALSE,
  REMOVE_ACCESS_ALERT,
  REMOVE_AUTOCALL,
  REMOVE_ISOPEN_ASSING,
  RESET_ASSIGN_ACCESS,
  SET_AUTOCALL,
  SET_ISOPEN_ASSING,
  BULK_UPLOAD_FAILED,
  BULK_UPLOAD_SUCCESS,
  UNDER_PROCESSING,
  LOADING_TRUE_ASSIGN,
} from '../actions/types';
const initialState = {
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  companyId: null,
  selectedId: null,
  editUserData: {},
  data: {},
  isOpen: false,
  autocall: false,
  isProcessing: false,
};

function assignAccessReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOADING_FALSE:
      return {
        ...state,
        data: {},
        loading: true,
      };
    case LIST_ASSIGN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.data.data,
      };
    case BULK_UPLOAD_FAILED:
      return {
        ...state,
        loading: false,
        isError: true,
        errMessage: payload.message,
        isErrorType: 'COMANY_LIST_ERROR',
      };
    case LIST_ASSIGN_USER_FAILED:
      return {
        ...state,
        loading: false,
        isError: false,
        data: {},
      };
    case REMOVE_ACCESS_ALERT:
      return {
        ...state,
        isError: false,
        isErrorType: null,
        errMessage: null,
      };
    case SET_AUTOCALL:
      return {
        ...state,
        autocall: true,
      };
    case REMOVE_AUTOCALL:
      return {
        ...state,
        autocall: false,
      };
    case RESET_ASSIGN_ACCESS:
      return {
        ...state,
        loading: true,
        isError: false,
        isErrorType: null,
        errMessage: null,
        companyId: null,
        selectedId: null,
        editUserData: {},
        data: {},
        isOpen: false,
        autocall: false,
      };
    case UNDER_PROCESSING:
      return {
        ...state,
        isProcessing: true,
      };
    case EDIT_ASSIGN_FAILED:
    case ADD_ASSIGN_FAILED:
      return {
        ...state,
        isError: true,
        isErrorType: payload.type,
        errMessage: payload.message,
        isProcessing: false,
      };
    case BULK_UPLOAD_SUCCESS:
    case EDIT_ASSIGN_SUCCESS:
    case ADD_ASSIGN_SUCCESS:
      return {
        ...state,
        isError: false,
        isErrorType: payload.type,
        errMessage: payload.message,
        isProcessing: false,
      };
    case SET_ISOPEN_ASSING:
      return {
        ...state,
        isOpen: true,
      };
    case REMOVE_ISOPEN_ASSING:
      return {
        ...state,
        isOpen: false,
        isError: false,
        errMessage: null,
        isErrorType: null,
      };
    case EDIT_USER_ASSIGN_DATA:
      return {
        ...state,
        editUserData: payload,
        isError: false,
        isErrorType: null,
        errMessage: null,
      };
    case LOADING_TRUE_ASSIGN:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}

export default assignAccessReducer;
